<div class="description">
  <div class="description__wrapper">
    <div class="description__sentence" [innerHtml]="template"></div>
    <div class="description__image"></div>
  </div>
</div>
